// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__ipmFe","loader":"loader_loader__1AOoV","rotation":"loader_rotation__a2Qf7"};